import { render, staticRenderFns } from "./ProductPagination.vue?vue&type=template&id=37d2fe3a&scoped=true&"
import script from "./ProductPagination.vue?vue&type=script&lang=js&"
export * from "./ProductPagination.vue?vue&type=script&lang=js&"
import style0 from "./ProductPagination.vue?vue&type=style&index=0&id=37d2fe3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d2fe3a",
  null
  
)

export default component.exports